import { NbaActions } from '@/types-nba';

/** TFP-3382: NBA action → h_event_action_007 */
const NBA_TRACKING_ACTION_MAP: Partial<Record<NbaActions, string>> = {
  [NbaActions.ADD_IMAGE]: 'add_images',
  [NbaActions.ADD_DOCUMENT]: 'add_document',
  [NbaActions.ADD_ADDRESS]: 'show_address',
  [NbaActions.IMPROVE_TITLE]: 'improve_title',
  [NbaActions.IMPROVE_DESCRIPTION]: 'improve_description',
  [NbaActions.BOOK_TOP_LISTING]: 'book_top_listing',
  [NbaActions.BOOK_PREMIUM_LISTING]: 'book_premium_listing',
  [NbaActions.BOOK_REGIONAL_HIGHLIGHT]: 'book_regional_highlight',
  [NbaActions.CHECK_PRICE_IAZI]: 'check_price',
};

export function getNbaTrackingAction(action: NbaActions): string {
  return NBA_TRACKING_ACTION_MAP[action] ?? action.toLowerCase();
}
